module.exports = __webpack_public_path__ + "img/456.7265e082.jpg";